<template>
  <v-snackbar
    v-model="feedback.show"
    :color="feedback.color"
    :timeout="feedback.timeout"
    location="end top"
  >
    <v-icon left v-if="feedback.icon">{{ feedback.icon }}</v-icon>
    {{ feedback.message }}
    <template #actions>
      <v-btn icon @click="closeFeedback">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["feedback"]),
  },
  methods: {
    ...mapActions(["closeFeedback"]),
  },
};
</script>
